<template>
  <div class="bg">
    <p class="order-num">订单号：{{ orderInfo.orderNum }}</p>
    <ul class="order-status-list">
      <li class="order-status-item" v-for="(item, index) in orderInfo.orderStatusList" :key="index">
        <span>{{ item.orderStatusName }}</span>
        <span>{{ item.orderStatusTime }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    orderInfo: [Object]
  }
};
</script>

<style lang="postcss" scoped>
.bg {
  padding: 20px 30px;
  font-size: 14px;
  color: #fff;
  background: url(//s1.huishoubao.com/static/pc/1001/img/19_07.png);
}

.order-status {
  &-list {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  &-item {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/orderDetails/floor-banner.vue